<template>
    <div>
        <div class="columns">
            <div class="column">
                <label class="label">Start</label>
                <input class="input oc-input" type="datetime" v-model="start" />
            </div>
            <div class="column">
                <label class="label">End</label>
                <input class="input oc-input" type="datetime" v-model="end" />
            </div>
            <div class="column">
                <a class="button is-pulled-right" @click="refresh">
                    <span class="icon">
                        <i class="fas fa-sync-alt"></i>
                    </span>
                    <span>Refresh</span>
                </a>
            </div>
        </div>

        <p class="title is-5">Bonuses</p>

        <table class="table is-fullwidth is-hoverable is-size-7">
            <thead>
                <tr>
                    <th>Id</th>
                    <th>Player</th>
                    <th>Type</th>
                    <th>Created</th>
                    <th>Start amount</th>
                    <th>Active amount</th>
                    <th>Bet progress</th>
                    <th>Payout</th>
                    <th>Completed at (reason)</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="bonus in bonuses" :key="bonus.id">
                    <td>{{bonus.id}}</td>
                    <td>
                        <router-link
                            :to="{ name: 'player', params: { clientId: clientId, playerId: bonus.userId } }"
                        >{{ bonus.userId }}</router-link>
                    </td>
                    <td>{{bonus.type}}</td>
                    <td>{{bonus.created | datetime}}</td>
                    <td>{{bonus.startAmount | currency(bonus.currency)}}</td>
                    <td>{{bonus.activeAmount | currency(bonus.currency)}}</td>
                    <td>{{bonus.betProgressPercent}}% {{bonus.betProgress | currency(bonus.currency)}} of {{bonus.betRequirement | currency(bonus.currency)}}</td>
                    <td>{{bonus.amount | currency(bonus.currency)}}</td>
                    <td
                        v-if="bonus.completed"
                    >{{bonus.completed | datetime}} ({{bonus.completeReason}})</td>
                    <td v-if="!bonus.completed">-</td>
                </tr>
            </tbody>
        </table>

        <p class="title is-5">Total</p>
        <table class="table is-fullwidth is-hoverable is-size-7">
            <thead>
                <tr>
                    <th>Currency</th>
                    <th>Count</th>

                    <th>Active</th>
                    <th>Completed</th>
                    <th>Played</th>

                    <th>Start amount</th>
                    <th>Active amount</th>
                    <th>Payout</th>
                </tr>
            </thead>
            <tbody>
                <template v-for="cur in total">
                    <tr :key="`total_${cur.currency}`">
                        <td>{{cur.currency}}</td>
                        <td>{{cur.count}}</td>

                        <td>{{cur.activeCount}}</td>
                        <td>{{cur.completedCount}}</td>
                        <td>{{cur.playedCount}}</td>

                        <td>{{cur.startAmount | currency(cur.currency)}}</td>
                        <td>{{cur.activeAmount | currency(cur.currency)}}</td>
                        <td>{{cur.playedAmount | currency(cur.currency)}}</td>
                    </tr>
                    <tr :key="`details_${cur.currency}`">
                        <td colspan="8">
                            <table class="table is-fullwidth is-hoverable is-size-7">
                                <thead>
                                    <tr>
                                        <th>Type</th>
                                        <th>Count</th>

                                        <th>Active</th>
                                        <th>Completed</th>
                                        <th>Played</th>

                                        <th>Start amount</th>
                                        <th>Active amount</th>
                                        <th>Payout</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="type in cur.bonuses" :key="`details_${cur.currency}_type_${type.type}`">
                                        <td>{{type.type}}</td>
                                        <td>{{type.count}}</td>

                                        <td>{{type.activeCount}}</td>
                                        <td>{{type.completedCount}}</td>
                                        <td>{{type.playedCount}}</td>

                                        <td>{{type.startAmount | currency(cur.currency)}}</td>
                                        <td>{{type.activeAmount | currency(cur.currency)}}</td>
                                        <td>{{type.playedAmount | currency(cur.currency)}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>
<script>
import Vue from 'vue';
import moment from 'moment-timezone';
import bonusService from '../../../../services/bonus.service';
import currencyService from '../../../../services/currency.service';

export default {
    name: 'client-bonuses-playthrough',
    data() {
        return {
            start: moment()
                .startOf('week')
                .toDate(),
            end: moment()
                .endOf('week')
                .toDate(),
            bonuses: [],
            total: []
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        }
    },
    async created() {
        await currencyService.ensure();
        await this.refresh();
    },
    methods: {
        async refresh() {
            var data = await bonusService.getClientPlayThroughHistory(this.clientId, this.start, this.end);
            this.bonuses = data.bonuses;
            this.total = data.total;
        }
    }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/bonuses/playthrough.vue